// src/pages/TagManager.jsx
import React, { useEffect, useState } from "react";
import Tag from "../components/Tag";
import axiosBackend from "../api/axiosBackend";

// shadcn
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle as DialogTitleUI,
  DialogDescription,
} from "components/ui/dialog";

function TagManager() {
  const [tags, setTags] = useState([]);
  const [editTag, setEditTag] = useState(null);
  const [tagName, setTagName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axiosBackend.get("/tags/get");
        setTags(response.data);
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };
    fetchTags();
  }, []);

  const handleEditClick = (tag) => {
    setEditTag(tag);
    setTagName(tag.name);
  };

  const handleSaveClick = async () => {
    if (!editTag) return;
    if (!tagName.trim()) return; // simple guard; keep logic minimal
    setSaving(true);
    try {
      const response = await axiosBackend.put(`/tags/${editTag._id}`, { name: tagName.trim() });
      setTags((prev) => prev.map((t) => (t._id === editTag._id ? response.data : t)));
      setEditTag(null);
      setTagName("");
    } catch (error) {
      console.error("Error updating tag:", error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-background px-4 py-6" dir="rtl">
      <div className="container mx-auto">
        <Card className="mx-auto max-w-5xl">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-foreground">ניהול תגיות</CardTitle>
          </CardHeader>

          <CardContent>
            {/* Tag grid */}
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              {tags.map((tag) => (
                <div
                  key={tag._id}
                  className="flex items-center justify-between rounded-lg border p-2"
                >
                  <Tag name={tag.name} />
                  <Button variant="secondary" size="sm" onClick={() => handleEditClick(tag)}>
                    עריכה
                  </Button>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Edit dialog (uses your existing editTag/tagName state & save handler) */}
      <Dialog open={!!editTag} onOpenChange={(open) => !open && setEditTag(null)}>
        <DialogContent className="sm:max-w-md" dir="rtl">
          <DialogHeader>
            <DialogTitleUI>עריכת תג</DialogTitleUI>
            <DialogDescription>עדכן את שם התג ולחץ שמור.</DialogDescription>
          </DialogHeader>

          <div className="space-y-3">
            <Input
              value={tagName}
              onChange={(e) => setTagName(e.target.value)}
              placeholder="שם תג"
              autoFocus
            />

            <div className="flex justify-end gap-2">
              <Button variant="ghost" onClick={() => setEditTag(null)} disabled={saving}>
                ביטול
              </Button>
              <Button onClick={handleSaveClick} disabled={saving || !tagName.trim()}>
                {saving ? "שומר…" : "שמור"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default TagManager;
